import React, { createContext, useCallback, useContext, useState } from 'react';
interface IsPublicRouterContextData {
  handleIsPublicRouter(isPublic: boolean): void;
  IsPublicRouter: boolean;
}

const IsPublicRouterContext = createContext<IsPublicRouterContextData>(
  {} as IsPublicRouterContextData,
);

const IsPublicRouterProvider: React.FC = ({ children }) => {
  const [IsPublicRouter, setIsPublicRouter] = useState(false);

  const handleIsPublicRouter = useCallback((isPublic: boolean) => {
    setIsPublicRouter(isPublic);
    return;
  }, []);

  return (
    <IsPublicRouterContext.Provider
      value={{ handleIsPublicRouter, IsPublicRouter }}
    >
      {children}
    </IsPublicRouterContext.Provider>
  );
};

function useIsPublicRouter(): IsPublicRouterContextData {
  const context = useContext(IsPublicRouterContext);

  if (!context) {
    throw new Error('useToast must used within a ToastProvider');
  }

  return context;
}

export { IsPublicRouterProvider, useIsPublicRouter };
